/**
 * @generated SignedSource<<d5c44ff334d72ce23b6ba67e54dc83f4>>
 * @relayHash 50e507718df928ca064395fd318fe70c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b6181355159d14cf0c9ada0391cd828e5ee038e19889e4f67c31e1b2b687f2aa

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_prefetchCascadingSelectFieldOptionsQuery$variables = {
  first?: number | null | undefined;
  id: string;
};
export type ui_prefetchCascadingSelectFieldOptionsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment">;
};
export type ui_prefetchCascadingSelectFieldOptionsQuery = {
  response: ui_prefetchCascadingSelectFieldOptionsQuery$data;
  variables: ui_prefetchCascadingSelectFieldOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = [
  (v2/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  (v6/*: any*/),
  {
    "kind": "ScalarField",
    "name": "value"
  },
  {
    "kind": "ScalarField",
    "name": "optionId"
  },
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_prefetchCascadingSelectFieldOptionsQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "cascadingSelect_issueFieldCascadingSelectEditviewFull_CascadingSelectEditViewWithFieldOptionsFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ui_prefetchCascadingSelectFieldOptionsQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "JiraCascadingOptionsConnection",
                "kind": "LinkedField",
                "name": "cascadingOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraCascadingOptionsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraCascadingOptions",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "parentOptionValue",
                            "plural": false,
                            "selections": (v7/*: any*/)
                          },
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "childOptionValues",
                            "plural": true,
                            "selections": (v7/*: any*/)
                          },
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v5/*: any*/),
                "handle": "connection",
                "key": "cascadingSelect_issueFieldCascadingSelectEditviewFull_cascadingOptions",
                "kind": "LinkedHandle",
                "name": "cascadingOptions"
              }
            ],
            "type": "JiraCascadingSelectField"
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "b6181355159d14cf0c9ada0391cd828e5ee038e19889e4f67c31e1b2b687f2aa",
    "metadata": {},
    "name": "ui_prefetchCascadingSelectFieldOptionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4ea277c1bd2765da3a550f42a3098fc3";

export default node;
